import React from 'react';
import PropTypes from 'prop-types';
import { Card, IconButton } from '@totalsoft/rocket-ui';
import StateTransitionListComponent from './StateTransitionListComponent';
import { Prompt } from 'react-router-dom';
import { Ballot } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';
import CardNoResultsWrapper from 'components/layout/CardNoResultsWrapper';

const StateTransitionListCard = ({
  automaticStateTransitionRules,
  states,
  onSave,
  onAdd,
  onPropertyChanged,
  onDelete,
  onExpandChange,
  validation
}) => {
  const { t } = useTranslation();

  return (
    <Card
      icon={Ballot}
      iconColor='primary'
      title={t('AutomaticStateTransitions.StateTransitions')}
      actions={<IconButton color='transparent' fontSize='medium' type='add' tooltip={t('Tooltips.Add')} onClick={onAdd} />}
    >
      <>
        <Prompt
          when={automaticStateTransitionRules.some(x => x.changed)}
          message={t('AutomaticStateTransitionRules.LeavingWithoutSavingTransitionRule')}
        />
        <CardNoResultsWrapper content={automaticStateTransitionRules}>
          <StateTransitionListComponent
            automaticStateTransitionRules={automaticStateTransitionRules}
            states={states}
            onSave={onSave}
            onDelete={onDelete}
            onPropertyChanged={onPropertyChanged}
            onExpandChange={onExpandChange}
            validation={validation}
          />
        </CardNoResultsWrapper>
      </>
    </Card>
  );
};

StateTransitionListCard.propTypes = {
  automaticStateTransitionRules: PropTypes.array.isRequired,
  states: PropTypes.array.isRequired,
  onSave: PropTypes.func.isRequired,
  onAdd: PropTypes.func.isRequired,
  onPropertyChanged: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
  onExpandChange: PropTypes.func.isRequired,
  validation: PropTypes.object.isRequired
};
export default StateTransitionListCard;
